export default __webpack_public_path__ + "static/media/SEC0510.34I-18604_-14542_0.30682b71.jpg";